import { faRepeatAlt } from "@fortawesome/pro-regular-svg-icons";

import { toDollars, toPercent } from "common/utils/formatting";
import Icon from "common/components/Icon";

import { ProductCardBadgePrice, ProductCardBadge } from "../types";

type ProductCardBadgesProps = {
  badges: ProductCardBadge[];
  styles: Record<string, string>;
  maxBadges?: number;
};

// What the row fits on one line.
const MAX_BADGES = 2;

// A capped percent deal (max_savings set) can hit its dollar ceiling, so the rate is only an upper bound.
const badgeAmount = (badge: ProductCardBadge): string => {
  if (badge.percent != null) {
    const rate = `${toPercent(String(badge.percent))} off`;
    return badge.max_savings == null ? rate : `Up to ${rate}`;
  }
  const amount = toDollars(badge.savings_amount, { collapseWholeDollars: true });
  // An unapplied autoship rebate is money back after the order, not money off the price shown.
  return !badge.is_applied && badge.applies_to === ProductCardBadgePrice.Subscription
    ? `${amount} back`
    : `${amount} off`;
};

/** The default item's deals as card badges; renders nothing when the item has none. */
const ProductCardBadges = ({ badges, styles, maxBadges = MAX_BADGES }: ProductCardBadgesProps) => {
  if (!badges.length) {
    return null;
  }
  return (
    <div className={styles.discountRow}>
      {badges.slice(0, maxBadges).map((badge) => (
        <span
          key={`${badge.source}-${badge.promotion_id}-${badge.applies_to}`}
          className={styles.dealBadge}
        >
          {/* Titled, since the icon is the only thing marking the saving as autoship-only. */}
          {badge.applies_to === ProductCardBadgePrice.Subscription && (
            <Icon icon={faRepeatAlt} title="Autoship" />
          )}
          {badgeAmount(badge)}
          {!!badge.promo_code && <span className={styles.badgeCode}>{badge.promo_code}</span>}
        </span>
      ))}
    </div>
  );
};

export default ProductCardBadges;
